import parsePhoneNumberFromString from "libphonenumber-js";

export const formatPhoneNumber = (phoneNumber: string) => {
  const formattedPhoneNumber = parsePhoneNumberFromString(`+${phoneNumber}`);

  if (!formattedPhoneNumber) {
    return phoneNumber;
  }

  return formattedPhoneNumber.formatInternational();
};
